<script>
import { computed,nextTick,onMounted,ref, reactive} from 'vue'
export default {
  name: "TabsetProducts",
  setup(){
  const activeIndex =  ref(1)
		    const isOpened =  ref(false)
		    const currentHeight =  ref(0)
		    const navHeight =  ref(0)
		    const labels =  ref([])
		    const heights =  ref([])
        const panelsField = ref(null)
		    const classes =  reactive({tabs: {height: 50},panels: {height: 0} })
        const width = ref(window.innerWidth);
        function setActive(index) {
            let delta = heights.value[index - 1] - currentHeight.value;
           updateHeight(delta);
           activeIndex.value = index;
            jQuery('.tabset-products-trigger .titleValue').text(labels.value[index - 1]);
        };
        function isActive(index) {
            return index === activeIndex.value;
        };
        function getLabels(tabs) {
            return tabs.map(tab => tab.innerText);
        };
        function getHeights(newPanels) {
            return newPanels.map(panel => panel.children[0].offsetHeight);
        };
        function getNavHeight(nav) {
            nav.style.removeProperty("height");
            return nav.offsetHeight;
        };
        function fixHeights() {
            if(width.value < 480) {
                classes.tabs.height = "0px";
            }
        };
        function triggerNav() {
            isOpened.value = !isOpened.value;
            const height =isOpened.value ? navHeight.value : 0;
            classes.tabs.height = `${height}px`;
        };
        function updateHeight(delta) {
            const newHeight = currentHeight.value + delta;
            classes.panels.height = `${newHeight}px`;
            currentHeight.value = newHeight;
        };

        onMounted(async () => {
          await nextTick();
          panelsField.value = document.querySelector('.tabset-products-panels');
          const tabs = document.querySelector('.tabset-products-nav');
          if (panelsField.value && tabs) {

            heights.value = getHeights([...panelsField.value.children]);
            labels.value = getLabels([...tabs.children]);
            navHeight.value = getNavHeight(tabs);
            fixHeights();
            setActive(1);

          } else {
            console.warn("Elements not found!");
          }
        })

        return { classes, triggerNav, isActive, setActive }
      }
}

</script>


<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings

    @import tabset-products
    @import tab-products
    @import card-product-offer
</style>
